module.exports = __webpack_public_path__ + "media/images/oficinas/bs_as-f89532676e429e272ec5948ab1dbcf79.jpg";